import React from "react";
import { Form, Select } from "antd";
import { GSK_PHARMA_ID } from "../../../configs/constants";
const FormSelect = ({
  itemsSelect = [],
  formItemLayout,
  item,
  getFieldDecorator,
  defaultValue,
  disabled,
  placeholder,
  handleSelectChange,
  setKeyFilterSelected,
  disabledOnFocusFunction = false,
  label
}) => {
  return (
    <Form.Item {...formItemLayout} label={item} disabledOnFocusFunction={false}>
      {getFieldDecorator(item, {
        initialValue: defaultValue || null,
        rules: [{ required: true, message: `Le ${item} doit être choisi.` }]
      })(
        <Select
          disabled={disabled}
          placeholder={placeholder}
          showSearch
          onChange={handleSelectChange}
          onFocus={() => {
            if (!disabledOnFocusFunction) setKeyFilterSelected && setKeyFilterSelected(label);
          }}
        >
          {itemsSelect.map(item => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default FormSelect;

export const FormSelectId = ({
  //Attention : Spécifique au pdc label pour la planification
  itemsSelect,
  formItemLayout,
  getFieldDecorator,
  defaultValue,
  disabled,
  placeholder,
  handleSelectChange,
  keyId,
  label,
  originalLabel,
  clientId,
  ...props
}) => {
  const items = Array.isArray(itemsSelect) ? itemsSelect : [];
  const selectedItem = items.find(function(item) { return item[keyId] === defaultValue; });
  if (!selectedItem && defaultValue) items.push({ [keyId]: defaultValue, [label]: originalLabel });

  return (
    <Form.Item {...formItemLayout} label={props.item} disabledOnFocusFunction={false}>
      {getFieldDecorator(props.item, {
        initialValue: defaultValue ? defaultValue : null,
        rules: [{ required: true, message: `Le ${props.item} doit être choisi.` }]
      })(
        <Select
          disabled={disabled}
          placeholder={placeholder}
          showSearch
          onChange={handleSelectChange}
          onFocus={() => {
            if (!props.disabledOnFocusFunction) props.setKeyFilterSelected && props.setKeyFilterSelected(props.label);
          }}
          filterOption={(input, option) => {
            return typeof option.props.children === "string"
              ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false;
          }}
        >
          {items.map(item => {
            return (
              <Select.Option key={item[keyId]} value={item[keyId]}>
                {`${item[label]} ${item.city && clientId === GSK_PHARMA_ID ? `(${item.city})` : ""}`}
              </Select.Option>
            );
          })}
        </Select>
      )}
    </Form.Item>
  );
};



// WEBPACK FOOTER //
// src/components/planning/FormItems/FormSelect.js